import { get as _get } from 'lodash';

export const importReviewPiesColumns: any = [
  {
    title: 'select-all-btn',
    active: false,
    col: 'select-btn',
    cssWidth: '130px',
  },
  {
    title: 'Part no.',
    sortable: true,
    sort: 'desc',
    active: false,
    link: true,
    truncate: true,
    col: 'partNumber',
    cssWidth: '15%',
  },
  {
    title: 'Part Type',
    sortable: true,
    sort: 'desc',
    active: false,
    truncate: true,
    col: 'partTerminology',
    data: (row: any) => {
      return _get( row, 'details.partTerminology.name', _get(row, 'partTerminology.name', '') );
    },
    cssWidth: '15%',
  },
  {
    title: 'Product description',
    sortable: true,
    sort: 'desc',
    active: false,
    truncate: true,
    col: 'description_des_en',
    data: (row: any) => {
      return _get(row, 'descriptions.DES.EN', '');
    }
  },
  {
    title: 'Jobber price 1',
    columnName: 'price_jobber_1_usd',
    col: 'price_jobber_1_usd',
    sortable: true,
    sort: 'desc',
    active: false,
    type: 'currency',
    cssWidth: '110px',
    data: (row: any) => {
      return _get(row, 'price_jobber_1.USD');
    }
  },
  {
    title: 'Jobber price 2',
    columnName: 'price_jobber_2_usd',
    col: 'price_jobber_2_usd',
    sortable: true,
    sort: 'desc',
    active: false,
    type: 'currency',
    cssWidth: '110px',
    data: (row: any) => {
      return _get(row, 'price_jobber_2.USD');
    }
  },
  {
    title: 'Retail price 1',
    col: 'price_retail_1_usd',
    columnName: 'price_retail_1_usd',
    sortable: true,
    sort: 'desc',
    active: false,
    cssWidth: '110px',
    type: 'currency',
    data: (row: any) => {
      return _get(row, 'price_retailer_1.USD');
    }
  },
  {
    title: 'Retail price 2',
    columnName: 'price_retail_2_usd',
    col: 'price_retail_2_usd',
    sortable: true,
    sort: 'desc',
    active: false,
    cssWidth: '110px',
    type: 'currency',
    data: (row: any) => {
      return _get(row, 'price_retailer_2.USD');
    }
  },
];
